import React from 'react';
// Layout is provided by App.tsx route wrapper
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { Palette, Globe, CheckCircle, Settings, Moon, Sun } from 'lucide-react';

export const SettingsPage = () => {
    const { theme, toggleTheme } = useTheme();
    const { language, setLanguage, t } = useLanguage();
    const isDark = theme === 'dark';

    const bgCard = isDark ? 'bg-[var(--surface)] border-[var(--border)]' : 'bg-white border-[var(--border)]';
    const textMain = 'text-[var(--text-primary)]';
    const textSub = 'text-[var(--text-secondary)]';

    // Componente interno para la tarjeta de tema seleccionable
    const ThemeOption = ({ mode, icon: Icon, label, active }: any) => (
        <button
            onClick={() => { if (!active) toggleTheme(); }}
            className={`flex-1 p-6 rounded-2xl border-2 transition-all relative group overflow-hidden ${active
                ? 'border-[#F26430] bg-[#F26430]/10'
                : (isDark ? 'border-[var(--border)] hover:border-gray-500 bg-transparent' : 'border-[var(--border)] hover:border-gray-300 bg-gray-50')
                }`}
        >
            {active && (
                <div className="absolute top-3 right-3 flex items-center gap-2 animate-fade-in">
                    <span className="text-[10px] font-bold text-[#F26430] uppercase tracking-wider">
                        {language === 'es' ? 'Predeterminado' : 'Default'}
                    </span>
                    <div className="bg-[#F26430] text-white rounded-full p-0.5">
                        <CheckCircle size={14} />
                    </div>
                </div>
            )}

            <div className="flex flex-col items-center justify-center pt-2">
                <Icon className={`w-8 h-8 mb-3 ${active ? 'text-[#F26430]' : 'text-[var(--text-secondary)]'}`} />
                <span className={`text-sm font-bold ${active ? 'text-[#F26430]' : textSub}`}>{label}</span>
            </div>
        </button>
    );

    return (
        <>
            <div className="w-full max-w-4xl mx-auto space-y-8 p-8">
                <h1 className={`text-3xl font-bold flex items-center gap-3 ${textMain}`}>
                    <div className="p-2 bg-[#F26430] rounded-lg text-white"><Settings size={24} /></div>
                    {t('settings', 'title')}
                </h1>

                <div className="grid grid-cols-1 gap-8">

                    {/* TARJETA TEMA */}
                    <div className={`p-8 rounded-xl border shadow-sm ${bgCard}`}>
                        <h3 className={`text-lg font-bold mb-6 flex items-center gap-2 ${textMain}`}>
                            <Palette className="w-5 h-5 text-[#3A7CA5]" /> {t('settings', 'appearance')}
                        </h3>

                        <div className="flex gap-6">
                            <ThemeOption mode="light" icon={Sun} label="Aipron Light" active={!isDark} />
                            <ThemeOption mode="dark" icon={Moon} label="Dark Enterprise" active={isDark} />
                        </div>
                        <p className={`text-xs mt-4 text-center ${textSub}`}>
                            {language === 'es'
                                ? '* Tu preferencia se guardará automáticamente para futuras sesiones.'
                                : '* Your preference will be saved automatically for future sessions.'}
                        </p>
                    </div>

                    {/* TARJETA IDIOMA */}
                    <div className={`p-8 rounded-xl border shadow-sm ${bgCard}`}>
                        <h3 className={`text-lg font-bold mb-6 flex items-center gap-2 ${textMain}`}>
                            <Globe className="w-5 h-5 text-green-500" /> {t('settings', 'language')}
                        </h3>
                        <div className={`flex items-center px-4 py-3 rounded-lg border ${isDark ? 'bg-white border-[var(--border)]' : 'bg-gray-50 border-gray-300'}`}>
                            <select
                                value={language}
                                onChange={(e) => setLanguage(e.target.value as any)}
                                className={`w-full bg-transparent outline-none font-medium cursor-pointer ${textMain}`}
                            >
                                <option value="es" className="text-black">🇪🇸 Español (España)</option>
                                <option value="en" className="text-black">🇬🇧 English (International)</option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};